__turbopack_context__.v({
  "buttonIcon": "query-suggestion-module__MczYKq__buttonIcon",
  "buttonText": "query-suggestion-module__MczYKq__buttonText",
  "container": "query-suggestion-module__MczYKq__container",
  "description": "query-suggestion-module__MczYKq__description",
  "discoverButton": "query-suggestion-module__MczYKq__discoverButton",
  "hidden": "query-suggestion-module__MczYKq__hidden",
  "mobileButton": "query-suggestion-module__MczYKq__mobileButton",
  "title": "query-suggestion-module__MczYKq__title",
  "visible": "query-suggestion-module__MczYKq__visible",
});
